import React from 'react'
import Header from '../Components/Component/Header'
import Blog_Post from '../Components/Component/Blog_Post'
import Blog_Down from '../Components/Component/Blog_Down'
import Footer from '../Components/Component/Footer'
const Blog = () => {
  return (
    <div>
       
        <Blog_Post />
        <Blog_Down />
        <Footer />
    </div>
  )
}

export default Blog